/* eslint-disable security/detect-unsafe-regex */
export const ZoneRegex =
  /^(([A-Za-z]{2}-)?([A-Za-z]{2,3}-)?([A-Za-z]{2,3}-)?)?[A-Za-z]{2,3}-[0-9A-Za-z]{3,20}(-[A-Za-z])?$/;
